import * as yup from 'yup';
import { cFormValidationMessages } from '../../constants/validationMessages';

export const cFieldNames = {
    solverNetId: 'solverNetId',
    plannedActionDescription: 'plannedActionDescription',
    plannedDate: 'plannedDate',
    actionSolvedDescription: 'actionSolvedDescription',
    actionSolvedDate: 'actionSolvedDate',
    safetyImpact: 'safetyImpact',
};

export const validationSchema = (t: any) => {
    return yup.object().shape({
        [cFieldNames.solverNetId]: yup.string().required(t(cFormValidationMessages.required)),
    });
};
